document.addEventListener('page:loaded', function() {
jQuery(function($) {
    jQuery(document).ready(function(){  
       // accordion
      jQuery(".category_desc_section .fc-item .field__accordion-heading, .hw_descp .fc-item .field__heading-data").on("click", function(){
        jQuery(this).siblings(".field__accordion-descriptions, .field__description-data").slideToggle();
        jQuery(this).toggleClass("active");
        if(jQuery(this).parent(".fc-item").siblings().children(".field__accordion-descriptions, .field__description-data").is(":visible")){
          jQuery(this).parent(".fc-item").siblings().children(".field__accordion-descriptions, .field__description-data").slideUp();
          jQuery(this).parent(".fc-item").siblings().children(".field__accordion-heading, .field__heading-data").removeClass("active");
          jQuery(this).siblings(".field__accordion-descriptions, .field__description-data").slideDown();
          jQuery(this).addClass("active");
        }
      })
      
  //Leg Slider 
  $('.leg-slider, .slider_home, .kt_story_slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    autoplay:false,
    arrows: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow:'<button type="button" class="slick-prev pull-left"><img class="black_ar" src="https://cdn.shopify.com/s/files/1/0387/3243/1404/files/prev.png?v=1600462668" alt=""><img class="black_wh" src="https://cdn.shopify.com/s/files/1/0387/3243/1404/files/prev_white.png?v=1600462829" alt=""></button>',
    nextArrow:'<button type="button" class="slick-next pull-right"><img class="black_ar" src="https://cdn.shopify.com/s/files/1/0387/3243/1404/files/next.png?v=1600461829" alt=""><img class="black_wh" src="https://cdn.shopify.com/s/files/1/0387/3243/1404/files/next_white.png?v=1600462829" alt=""></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
$('.kt-product-slider-sec .nit-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    autoplay:false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

var timeInt = parseInt($(".banner_slider").attr('data-time'), 10);
var autoSlide = $(".banner_slider").attr('data-slide') === 'true';
var home_slider = $('.hero_banner_sec .banner_slider');

home_slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    infinite: true,
    speed: timeInt || 300,  // Default to 300 if timeInt is not a valid number
    autoplay: autoSlide
});

// ...legslider arrow
  $('.leg-slider').slick({

    prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.84984 15.0298L0.589844 7.76979L7.57984 0.779785" stroke="#333F4C" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button type="button" class="slick-next pull-right"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.34961 0.779785L8.60961 8.02979L1.60961 15.0298" stroke="#333F4C" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  });
    }); 


});
 var $jq = jQuery.noConflict();
$jq(document).ready(function(){
    // you may like slider ..

          
   var jQuerycarousel = $jq('.custom-slider');
var customslid =  $jq('.custom-slider');       
  $jq('.custom-slider').slick({
        slidesToShow: 3.2,
        slidesToScroll: 1,
        arrrows:false,
        prevArrow: '.leftbtn',
        nextArrow: '.rightbtn',
        infinite:false,
        autoplay:false,
        centerMode: false,
        centerPadding:'100px',
        responsive:[
          {
            breakpoint: 767,
            settings: {
              slidesToShow:1,
              centerMode: true,
              infinite:true,
              centerPadding:'40px',
              dots: true,
              arrows: false
            }
          }
        ]
    });
  // jQuerycarousel.slick('slickGoTo', 1);
});

jQuery(document).ready(function(){
  jQuery('.section-heading-wrap .hw_descp p strong').click(function(){
  // jQuery('.section-heading-wrap .hw_descp p').removeClass('active');
 jQuery(this).parent().toggleClass('active')
})

  // add to cart btn on visible js....
function isVisible($el) {
  var winTop = $jq(window).scrollTop();
  var winBottom = winTop + $jq(window).height();
  var elTop = $el.offset().top;
  var elBottom = elTop + $el.height();
  return ((elBottom<= winBottom) && (elTop >= winTop));
}

jQuery(function() {
  jQuery(window).scroll(function() {
    if($jq('body').hasClass('template-product')){
    if(isVisible(jQuery(".payment-buttons"))){
        jQuery(".add-to-cart.float").removeClass('active-cart')

    }else {
     jQuery(".add-to-cart.float").addClass('active-cart')
    }
      }
    // $("#msg").text();
  });
});

// loader fadeout..
  
  // $(window).load(function() { $('.loader').fadeOut(250); })

// hover effect content prd detail page js....
  
jQuery('.hover_effect h3').on('click', function(){
   jQuery('.mobile-hotspot-tab-content-wrapper .hover_effect').removeClass('active');
   jQuery('.hover_effect h3').removeClass('active');
  let selectedElem =  jQuery(this).attr('data-id');
  jQuery(this).addClass('active')
  jQuery('#'+selectedElem).addClass('active')
})

// jQuery(".custom-slider").flickity({
//     pageDots: false,
//     groupCells: 3,
//     accessibility: true, //true by default
//     autoPlay: false // advance cells every 3 seconds
// });
  
  var jQuerycarousel = jQuery('.ooo-instagram-feed__list');
//    setTimeout(function(){
//      jQuery('.ooo-instagram-feed__list').slick({
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         arrrows:false,
//         prevArrow: '<button class="insta-leftbtn"><i class="fal fa-angle-left"></i></button>',
//         nextArrow: '<button class="insta-rightbtn"><i class="fal fa-angle-right"></i></button>',
//         infinite:false,
//         autoplay:false,
//         centerMode: true,
//         centerPadding:'50px',
//         responsive:[
//           {
//             breakpoint: 576,
//             settings: {
//               slidesToShow:1
//             }
//           }
//         ]
//     });

// },2000);

// fetch(`https://d3ejra0xbg20rg.cloudfront.net/instagram/media?shop=kt-health.myshopify.com&resource=default`).then((response) => {
//     response.json().then((media) => {
//        console.log(media)
//     });


jQuery('.popup-btn').click(function(){
  jQuery('.domes-popup-custom').slideToggle('hide');
  });

// jQuery("span.quick-product__label.link.btn").on('click',function(){
//   jQuery(this).find("modal").addClass("modal--is-active");
// });
  
});

// jQuery(document).ready(function(){
//   jQuery(document).ajaxStart(function(settings){
//    console.log('hsdfklajkljsdaklfjlkds', settings)
//   });
//   jQuery(document).ajaxComplete(function(settings){
//    console.log('complete---', settings)
//   });
// });


// Team Js
jQuery(document).ready(function(){
  jQuery(".tab_nav li a").click(function(){
    jQuery(this).parent().parent().find(".active").removeClass("active");
    jQuery(this).addClass("active");
    jQuery(".our_team > div").addClass("not_working");
    var sclass=jQuery(this).attr("data-rel");
    jQuery("."+sclass).removeClass("not_working");
  });
  //Add Class Blog Mobile Menu
  jQuery(".header_blogs .bar").click(function(){
  jQuery(".header_blogs .header-box").toggleClass("open-blog-menu");
});
  // End Add Class Blog Mobile Menu
 
});


jQuery(document).ready(function(){
  jQuery('.link-btn').on("click", function (event) {  
    jQuery(".how-to-apply-tips").toggle();
    jQuery(".link-btn span").toggleClass('less more');
  });

// Below JS code written by N S on 29-Feb-2024

$('body').on('click','.product-page-below-video .lty-playbtn',function(){
  
        $('#videoModalOther').addClass('modal--is-active');
  $('body').addClass('modal-open');
  //$('#videoModalOther iframe')[0].play();
  let src = $('#videoModalOther iframe').attr('src');
    $('#videoModalOther iframe').attr('src',src+'&autoplay=1');
})
$('body').on('click','#videoModalOther .modal__close',function(e){
  e.preventDefault()
  
  $('#videoModalOther').removeClass('modal--is-active');
  $('body').removeClass('modal-open');
  $('#videoModalOther iframe')[0].pause();
  return false
})
});

    

/**
 * A lightweight youtube embed. Still should feel the same to the user, just MUCH faster to initialize and paint.
 *
 * Thx to these as the inspiration
 *   https://storage.googleapis.com/amp-vs-non-amp/youtube-lazy.html
 *   https://autoplay-youtube-player.glitch.me/
 *
 * Once built it, I also found these:
 *   https://github.com/ampproject/amphtml/blob/master/extensions/amp-youtube (👍👍)
 *   https://github.com/Daugilas/lazyYT
 *   https://github.com/vb/lazyframe
 */
class LiteYTEmbed extends HTMLElement {
    connectedCallback() {
        // Gotta encode the untrusted value
        // https://cheatsheetseries.owasp.org/cheatsheets/Cross_Site_Scripting_Prevention_Cheat_Sheet.html#rule-2---attribute-escape-before-inserting-untrusted-data-into-html-common-attributes
        this.videoId = encodeURIComponent(this.getAttribute('videoid'));
        const playLabel = this.getAttribute('playlabel');
        this.playLabel = playLabel ? encodeURIComponent(playLabel) : 'Play';

        /**
         * Lo, the youtube placeholder image!  (aka the thumbnail, poster image, etc)
         * There is much internet debate on the reliability of thumbnail URLs. Weak consensus is that you
         * cannot rely on anything and have to use the YouTube Data API.
         *
         * amp-youtube also eschews using the API, so they just try sddefault with a hqdefault fallback:
         *   https://github.com/ampproject/amphtml/blob/6039a6317325a8589586e72e4f98c047dbcbf7ba/extensions/amp-youtube/0.1/amp-youtube.js#L498-L537
         * For now I'm gonna go with this confident (lol) assertion: https://stackoverflow.com/a/20542029, though I'll use `i.ytimg` to optimize for origin reuse.
         *
         * Worth noting that sddefault is _higher_ resolution than hqdefault. Naming is hard. ;)
         * From my own testing, it appears that hqdefault is ALWAYS there sddefault is missing for ~10% of videos
         *
         * TODO: Do the sddefault->hqdefault fallback
         *       - When doing this, apply referrerpolicy (https://github.com/ampproject/amphtml/pull/3940)
         * TODO: Consider using webp if supported, falling back to jpg
         */
        this.posterUrl = `https://i.ytimg.com/vi/${this.videoId}/hqdefault.jpg`;
        // Warm the connection for the poster image
        LiteYTEmbed.addPrefetch('preload', this.posterUrl, 'image');


        this.style.backgroundImage = `url("${this.posterUrl}")`;

        let playBtn = this.querySelector('.lty-playbtn');

        if (!playBtn) {
            playBtn = document.createElement('button');
            playBtn.type = 'button';
            playBtn.classList.add('lty-playbtn');
            playBtn.title = decodeURIComponent(this.playLabel);
            this.append(playBtn);
        }

        // On hover (or tap), warm up the TCP connections we're (likely) about to use.
        this.addEventListener('pointerover', LiteYTEmbed.warmConnections, {once: true});

        // Once the user clicks, add the real iframe and drop our play button
        // TODO: In the future we could be like amp-youtube and silently swap in the iframe during idle time
        //   We'd want to only do this for in-viewport or near-viewport ones: https://github.com/ampproject/amphtml/pull/5003
        this.addEventListener('click', e => this.addIframe());
    }

    // // TODO: Support the the user changing the [videoid] attribute
    // attributeChangedCallback() {
    // }

    /**
     * Add a <link rel={preload | preconnect} ...> to the head
     */
    static addPrefetch(kind, url, as) {
        const linkElem = document.createElement('link');
        linkElem.rel = kind;
        linkElem.href = url;
        if (as) {
            linkElem.as = as;
        }
        document.head.append(linkElem);
    }

    /**
     * Begin pre-connecting to warm up the iframe load
     * Since the embed's network requests load within its iframe,
     *   preload/prefetch'ing them outside the iframe will only cause double-downloads.
     * So, the best we can do is warm up a few connections to origins that are in the critical path.
     *
     * Maybe `<link rel=preload as=document>` would work, but it's unsupported: http://crbug.com/593267
     * But TBH, I don't think it'll happen soon with Site Isolation and split caches adding serious complexity.
     */
    static warmConnections() {
        if (LiteYTEmbed.preconnected) return;

        // The iframe document and most of its subresources come right off youtube.com
        LiteYTEmbed.addPrefetch('preconnect', 'https://www.youtube-nocookie.com');
        // The botguard script is fetched off from google.com
        LiteYTEmbed.addPrefetch('preconnect', 'https://www.google.com');

        // Not certain if these ad related domains are in the critical path. Could verify with domain-specific throttling.
        LiteYTEmbed.addPrefetch('preconnect', 'https://googleads.g.doubleclick.net');
        LiteYTEmbed.addPrefetch('preconnect', 'https://static.doubleclick.net');

        LiteYTEmbed.preconnected = true;
    }

    addIframe(){
        const params = new URLSearchParams(this.getAttribute('params') || []);
        params.append('autoplay', '1');
        const iframeHTML = `
<iframe width="560" height="315" frameborder="0"
  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
  src="https://www.youtube-nocookie.com/embed/${this.videoId}?${params.toString()}"
></iframe>`;
        this.insertAdjacentHTML('beforeend', iframeHTML);
        this.classList.add('lyt-activated');
    }
}
// Register custome element
customElements.define('lite-youtube', LiteYTEmbed);

// Open external link into new window
// var links = document.links;
// for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
//   if (links[i].hostname !== window.location.hostname) {
//     links[i].target = '_blank';
//     links[i].relList.add('noreferrer', 'noopener');
//   }
// }


});
// Make all registered marks, TM, etc superscript
jQuery(document).ready(function() { 
jQuery('body :not(script,sup)').contents().filter(function() {
    return this.nodeType === 3;
}).replaceWith(function() {
    return this.nodeValue.replace(/[®†™]/g, '<sup>$&</sup>');
});

var closeButtonSelector = '.modal__close';
   // Click event handler for the close button
    jQuery(closeButtonSelector).on('click', function () {
        // Reload or refresh the product data after a short delay (adjust the delay as needed)
      location.reload();
    });
  
});

//For Cart Freeze Issue
// jQuery(document).ready(function() {
//     // Function to check if class exists and remove it after a delay
//     function removeIsLoadingClass() {
//         if (jQuery('.js-qty__wrapper').hasClass('is-loading')) {
//             setTimeout(function() {
//                 jQuery('.js-qty__wrapper').removeClass('is-loading');
//                 console.log('The class has been removed from the element.');
//             }, 2000);
//         } else {
//             console.log('The class does not exist on the element.');
//         }
//     }

//     jQuery(document).on("change", ".js-qty__num", function() {
//         console.log("Code Working");
//         removeIsLoadingClass();
//     });

//     jQuery(document).on("click", ".js-qty__adjust--plus", function() {
//         removeIsLoadingClass();
//     });

//     jQuery(document).on("click", ".js-qty__adjust--minus", function() {
//         removeIsLoadingClass();
//     });

//     setTimeout(removeIsLoadingClass, 3000);
// });
